<template>
  <div class="">
    <div class="tc c999" v-if="cuDiscountRate.length==0">该银行今天尚未发布报价</div>
    <div v-else>
      <div class="tl mb10"><span class="f14 c999">更新时间：{{new Date().pattern('yyyy-MM-dd')}}</span></div>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr class="hl30 c666" style="background: #FFF5F5">
          <td class="bFFD4D4" :rowspan="2">票据类型</td>
          <td class="brFFD4D4 btFFD4D4 bbFFD4D4" :rowspan="2">承兑行等级</td>
          <td class="brFFD4D4 btFFD4D4 bbFFD4D4" :rowspan="2">剩余期限范围</td>
          <td class="btFFD4D4 bbFFD4D4 brFFD4D4" :colspan="cuDiscountRate[0].arrayList ? cuDiscountRate[0].arrayList.length : 1">票面金额范围（万元）</td>
        </tr>

        <tr class="hl30" style="background: #FFF5F5">
          <td class="brFFD4D4 bbFFD4D4" v-for="(item3, index3) in cuDiscountRate[0].arrayList">{{item3.faceAmtRange}}</td>
        </tr>

        <tr class="hl40" v-for="(body, index3) in cuDiscountRate" :key="index3">
          <td class="bbccc brccc blccc" :rowspan="body.draftTypeTotal" v-if="body.draftTypeTotal">{{formatDict(body.draftType, 'draftType')}}</td>
          <td class="bbccc brccc c333 fb" :rowspan="body.acceptBankLevelTypeTotal" v-if="body.acceptBankLevelTypeTotal">{{formatDict(body.acceptBankLevelType, 'acceptBankLevelType')}}</td>
          <td class="bbccc brccc" v-html="body.daysLeft"></td>
          <td class="bbccc brccc c000 fb" v-for="(item3, index3) in body.arrayList">{{changeRate(item3.discountRate)}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'discountRateCardXY',
  props: ['cuDiscountRate'],
  methods: {
    // 利率
    changeRate (rate) {
      if (String(rate).indexOf('%') > -1) {
        return rate;
      } else if (rate) {
        return Number(rate).mul(100).toFixed('2') + '%';
      } else {
        return '0.00%';
      }
    }
  },
  created () {
    console.log('============', this.cuDiscountRate)
  }
}
</script>

<style lang="scss" scoped>
.fw500 {
  font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/components/common/DiscountRateCardXY.vue